
export const Inputs = [
    [
        
        {
            type: "password",
            label: { ar: "كلمة المرور", en: "Password" },
            placeholder: "**********",
            name: "password"
        },
        {
            type: "password",
            label: { ar: 'تأكيد كلمة المرور', en: "Password confirmation" },
            placeholder: "**********",
            name: "newPassword"
        },
    ]

];